import React from 'react';
import { MapPin, Activity, ShieldCheck, Eye } from 'lucide-react';
import { HERO_IMAGES } from '../mock';

const Tracking = () => {
  return (
    <section className="section relative overflow-hidden bg-[#0A1628]">
      <div className="absolute inset-0 z-0 brand-gradient" />
      <div className="absolute inset-0 z-0 opacity-20">
        <img src={HERO_IMAGES.door} alt="Door-to-door auto transport delivery service" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1628]/70" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-[#2AA8E8]">Excelence Track 360™</span>
            <h2 className="mt-3 text-4xl md:text-5xl font-extrabold leading-tight">
              Live GPS tracking — from pickup to your driveway.
            </h2>
            <p className="mt-4 text-lg text-white/80">
              Know where your vehicle is at every moment. The instant we assign your driver, you can follow the journey in real time — on any device, 24/7.
            </p>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: Activity, title: 'Real-time updates', copy: 'Every milestone — dispatched, en route, delivered.' },
                { icon: Eye, title: '24/7 visibility', copy: 'Access tracking any time of day or night.' },
                { icon: ShieldCheck, title: 'Secure & private', copy: 'Encrypted links shared with you only.' },
                { icon: MapPin, title: 'Door to door', copy: 'Delivered to the address you choose.' },
              ].map(({ icon: Icon, title, copy }, i) => (
                <div key={i} className="flex gap-3 bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
                  <div className="w-10 h-10 rounded-lg bg-[#D4A24C]/20 flex items-center justify-center shrink-0">
                    <Icon className="w-5 h-5 text-[#D4A24C]" />
                  </div>
                  <div>
                    <div className="font-bold text-sm">{title}</div>
                    <div className="text-xs text-white/70 mt-0.5">{copy}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Tracking UI mockup */}
          <div className="relative">
            <div className="relative bg-white rounded-2xl shadow-2xl p-6 border border-white/20">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-[#4A5A72]">Shipment #EXC-48271</div>
                  <div className="text-lg font-extrabold text-[#0A1628]">New York, NY → Los Angeles, CA</div>
                </div>
                <span className="px-3 py-1 rounded-full bg-green-50 text-green-700 text-xs font-bold">In transit</span>
              </div>
              {/* progress */}
              <div className="relative h-2 bg-[#F0F3F8] rounded-full overflow-hidden mb-6">
                <div className="h-full w-[62%] bg-gradient-to-r from-[#0A1628] to-[#D4A24C] rounded-full" />
              </div>
              {/* route points */}
              <div className="space-y-4">
                {[
                  { label: 'Pickup — New York, NY', time: 'Apr 14, 09:12 AM', done: true },
                  { label: 'In transit — Oklahoma City, OK', time: 'Apr 16, 03:40 PM', done: true, active: true },
                  { label: 'Delivery — Los Angeles, CA', time: 'ETA Apr 18, 11:00 AM', done: false },
                ].map((r, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className={`mt-1 w-3 h-3 rounded-full ${r.active ? 'bg-[#D4A24C] ring-4 ring-[#D4A24C]/20' : r.done ? 'bg-[#0A1628]' : 'bg-[#E5EAF2]'}`} />
                    <div className="flex-1 flex justify-between">
                      <div>
                        <div className="text-sm font-bold text-[#0A1628]">{r.label}</div>
                        <div className="text-xs text-[#4A5A72]">{r.time}</div>
                      </div>
                      {r.active && <span className="text-xs font-bold text-[#D4A24C]">Live</span>}
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-4 border-t border-[#F0F3F8] flex items-center justify-between text-sm">
                <div>
                  <div className="text-[#4A5A72] text-xs">Driver</div>
                  <div className="font-semibold text-[#0A1628]">Marco A. · Peterbilt 579</div>
                </div>
                <div className="text-right">
                  <div className="text-[#4A5A72] text-xs">Miles to go</div>
                  <div className="font-extrabold text-[#0A1628]">1,058</div>
                </div>
              </div>
            </div>
            {/* decorative */}
            <div className="absolute -bottom-5 -right-5 w-24 h-24 rounded-2xl bg-[#D4A24C] -z-10 rotate-6" />
            <div className="absolute -top-4 -left-4 w-16 h-16 rounded-xl border-2 border-[#D4A24C]/40 -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tracking;
